// Helpers to get favicon url from SSP name (from bidder key-values)
// Doesn't include s2s variants, keys have to be lowercase
const sspDomains = {
  adx: 'https://admanager.google.com/',
  google: 'https://admanager.google.com/',
  openbidding: 'https://admanager.google.com/',
  amazon: 'https://advertising.amazon.com/',
  setupad: 'https://setupad.com/',
  dblock: 'https://d-block.fr/',
  insticator: 'https://www.insticator.com/',
  ogury: 'https://ogury.com/',
  smilewanted: 'https://www.smilewanted.com/',
  sparteo: 'https://sparteo.com/',
  unruly: 'https://nexxen.com/',
  seedtag: 'https://www.seedtag.com/',
  kueezrtb: 'https://weare.kueez.com/',
  projectagora: 'https://projectagora.com/',
  ix: 'https://www.indexexchange.com/',
  indexexchange: 'https://www.indexexchange.com/',
  rubicon: 'https://rubiconproject.com/',
  smartadserver: 'https://smartadserver.com/',
  adform: 'https://site.adform.com/',
  appnexus: 'https://www.appnexus.com',
  appnexusAst: 'https://www.appnexus.com',
  criteo: 'https://www.criteo.com/',
  pulsepoint: 'https://pulsepoint.com/',
  rtbhouse: 'https://www.rtbhouse.com/',
  pubmatic: 'https://pubmatic.com/',
  adagio: 'https://adagio.io/',
  '33across': 'https://www.33across.co.uk/',
  openx: 'https://www.openx.com/',
  connectad: 'https://connectad.ca/',
  districtm: 'https://www.districtm.net/',
  districtmdmx: 'https://www.districtm.net/',
  improvedigital: 'https://www.improvedigital.com/',
  sovrn: 'https://www.sovrn.com/',
  decenterads: 'https://decenterads.com/',
  emxdigital: 'https://emxdigital.com/',
  brealtime: 'https://emxdigital.com/',
  fidelity: 'https://fidelity-media.com/',
  lrytas: 'https://www.lrytas.lt/',
  luponmedia: 'https://luponmedia.com/',
  'Media bitės': 'https://www.mediabites.lt/',
  etaplius: 'https://www.etaplius.lt/',
  eskimi: 'https://eskimi.com/',
  conversant: 'https://www.conversantmedia.eu/',
  epsilon: 'https://www.epsilon.com',
  kasvyksta: 'https://kasvyksta.lt/',
  luponmedia: 'https://luponmedia.com/',
  etaplius: 'https://www.etaplius.lt/',
  adyoulike: 'https://www.adyoulike.com/',
  nobid: 'https://www.nobid.io/',
  amx: 'https://adaptmx.com/',
  rise: 'https://cloudfront.risecodes.com/',
  medianet: 'https://www.media.net/',
  vidazoo: 'https://perion.com/',
  triplelift: 'https://triplelift.com/',
  livewrapped: 'https://www.livewrapped.com/',
  sharethrough: 'https://www.sharethrough.com/',
  nextMillennium: 'https://www.nextmillennium.com/',
  onetag: 'https://www.onetag.com/',
  oftmedia: 'https://152media.com/',
  holid: 'https://holid.io/',
  admatic: 'https://admatic.com/',
  bcmssp: 'https://www.brightcom.com/',
  bidinfluence: 'https://bidinfluence.com/',
  between: 'https://betweendigital.com/',
  adtelligent: 'https://adtelligent.com/',
};

const getSSPLogo = (bidder, attributeGroups) => {
  if (!attributeGroups) {
    return null;
  }
  let normalizedBidder = bidder.toLowerCase().replace('s2s', '');
  // attributeGroups takes precedence over sspDomains
  const lowercasedAttributes = Object.keys(attributeGroups).reduce((acc, key) => {
    acc[key.toLowerCase()] = attributeGroups[key];
    return acc;
  }, {});
  const domain = Object.assign({}, sspDomains, lowercasedAttributes)[normalizedBidder];
  return domain ? `https://www.google.com/s2/favicons?domain=${domain}` : null;
};

module.exports = {
  getSSPLogo,
};
